module.exports = __webpack_public_path__ + "static/img/Knight of Cups.09d9e22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Knight of Cups.jpg
// module id = 1279
// module chunks = 0